// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HomeBanner-container-DadGj {
    margin: 0 auto;
    max-width: 1274px;
    padding: 0 24px;
}

.HomeBanner-sectionWidth-CVjue {
    max-width: 770px;
    margin: 0 auto;
}

.HomeBanner-pageContainer-H8RX_ {
    padding-top: 48px;
}

@media screen and (max-width: 1024px) {
    .HomeBanner-pageContainerMb-RRZe_ {
        padding-top: 0;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Home/HomeBanner/HomeBanner.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI;QACI,cAAc;IAClB;AACJ","sourcesContent":[".container {\n    margin: 0 auto;\n    max-width: 1274px;\n    padding: 0 24px;\n}\n\n.sectionWidth {\n    max-width: 770px;\n    margin: 0 auto;\n}\n\n.pageContainer {\n    padding-top: 48px;\n}\n\n@media screen and (max-width: 1024px) {\n    .pageContainerMb {\n        padding-top: 0;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `HomeBanner-container-DadGj`,
	"sectionWidth": `HomeBanner-sectionWidth-CVjue`,
	"pageContainer": `HomeBanner-pageContainer-H8RX_`,
	"pageContainerMb": `HomeBanner-pageContainerMb-RRZe_`
};
module.exports = ___CSS_LOADER_EXPORT___;
